import { render, staticRenderFns } from "./CommunityListDetail.vue?vue&type=template&id=a51dbd52&"
import script from "./CommunityListDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports